// Module
var code = `<div class="dropdown-placeholder float-right"> <s-multi-select-input items="items" on-item-toggle="onItemToggle()" show-items-in-modal="showItemsInModal()" toggle-items-dropdown="toggleItemsDropdown()"/> <s-multi-select-items is-desktop ng-if="showDropdownList" items="items" on-item-toggle="onItemToggle()"/> </div> `;
// Exports
var _module_exports =code;;
var path = '/common/directives/multiSelect/multiSelect.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;